import * as React from 'react';
import { Alert } from 'reactstrap';
import Icon from './Icons';

type Props = {
  children: React.ReactNode;
};

const WarningAlert: React.FunctionComponent<Props> = ({ children }) => {
  return (
    <Alert style={{ background: `rgb(239, 232, 174)`, marginTop: 25 }}>
      <Icon.Exclamation fill="#db822e" style={{ marginRight: 10 }} />
      {children}
    </Alert>
  );
};

export default WarningAlert;
